/**
 * 更新续保信息
 */
import Mock from 'mockjs'
import cache from '../../common/cache'

const mock = cache.getSessionData('mock')
const mockSwitch = mock ? '' : '_'

/**
 * 获取系统数据和保司数据不同点
 */
Mock.mock(/quote_renewal\/diff/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'after': [
        '2012-06-29'
      ],
      'before': [
        '2019-06-06'
      ],
      'eng_name': 'sold_at',
      'name': '注册日期'
    },
    {
      'after': [
        '沃尔沃VOLVO S60 1.6T轿车'
      ],
      'before': [
        ''
      ],
      'eng_name': 'brand_model_desc',
      'name': '品牌型号'
    },
    {
      'after': [
        252800
      ],
      'before': [
        ''
      ],
      'eng_name': 'purchase_price',
      'name': '新车购置价'
    },
    {
      'after': [
        5
      ],
      'before': [
        ''
      ],
      'eng_name': 'seat_number',
      'name': '座位数'
    },
    {
      'after': [
        '2019-06-26'
      ],
      'before': [
        '2019-06-05'
      ],
      'eng_name': 'business_ins_expires_on',
      'name': '商业险到期日'
    },
    {
      'after': [
        '2019-06-26'
      ],
      'before': [
        '2019-06-06'
      ],
      'eng_name': 'force_ins_expires_on',
      'name': '交强险到期日'
    },
    {
      'after': [
        '10516003980093716102'
      ],
      'before': [
        null
      ],
      'eng_name': 'business_policy_number',
      'name': '商业险保单号'
    },
    {
      'after': [
        '10516003900451424249'
      ],
      'before': [
        null
      ],
      'eng_name': 'force_policy_number',
      'name': '交强险保单号'
    },
    {
      'after': [
        '中国平安财产保险股份有限公司'
      ],
      'before': [
        '中国人寿财产保险有限公司'
      ],
      'eng_name': 'insurance_company',
      'name': '保险公司'
    },
    {
      'after': [
        32
      ],
      'before': [
        35
      ],
      'eng_name': 'insurance_company_id',
      'name': '保险公司id'
    },
    {
      'after': [
        '机动车损失保险(145107元)',
        '机动车第三者责任保险(1000000元)',
        '车上人员责任保险（驾驶员）(10000元)',
        '车上人员责任保险（乘客）(10000元)',
        '玻璃单独破碎险(进口)',
        '机动车损失保险无法找到第三方特约险',
        '不计免赔率（车损险）',
        '不计免赔率（三者险）',
        '不计免赔率（车上人员责任险（司机））',
        '不计免赔率（车上人员责任险（乘客））'
      ],
      'before': [],
      'eng_name': 'policy_type',
      'name': '投保险种及保额'
    }
  ],
  'message': '查询车辆信息成功！'
})

/**
 * 确定更新
 */
Mock.mock(/quote_renewal\/update/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})
